// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20385e98","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Header/Header.vue
// module id = 1397
// module chunks = 2